import { render, staticRenderFns } from "./original.vue?vue&type=template&id=21d8eb6a&scoped=true"
import script from "./original.vue?vue&type=script&lang=js"
export * from "./original.vue?vue&type=script&lang=js"
import style0 from "./original.vue?vue&type=style&index=0&id=21d8eb6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8eb6a",
  null
  
)

export default component.exports